import cn from 'clsx'

// Components
import ArticleCategories from 'components/articles/categories'
import { Link, Image } from '@tracklib/kit'

// Types
import type { CmsPage } from 'types'

import styles from './item.css'

type ArticleItemProps = {
  article: CmsPage
  isBig?: boolean
  className?: string
  title?: string
  owner?: string
  image?: string | number
}

const ArticleItem = ({ article, isBig, className, title, owner, image }: ArticleItemProps): JSX.Element => {
  const t = title || article.title
  const { summary, author, categories } = article
  const permalink = `/blog/${article.meta.slug}/`
  // const content = article.content
  const imageId = image || (article.image && article.image.id)

  return (
    <article className={cn(styles.item, isBig && styles.itemBig, className)} datatesting="article_item">
      <Link to={permalink} className={styles.image}>
        {imageId && <Image image={imageId} alt={t} absolute lazy />}
      </Link>
      <div className={styles.content} datatesting="article_info">
        <div>
          <span className={styles.time}>
            {author && (
              <span>
                By{' '}
                <Link to={`/user/${author.id}/`} itemProp="author">
                  {owner || author.alias}
                </Link>{' '}
              </span>
            )}{' '}
          </span>
          <h2 className={styles.title}>
            <Link to={permalink}>{t}</Link>
          </h2>
          <Link to={permalink} className={styles.summary}>
            {summary}
          </Link>
        </div>

        <footer>{categories && <ArticleCategories categories={categories} />}</footer>
      </div>
    </article>
  )
}

export default ArticleItem
